import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEditieren = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "29px",
	height: "29px",
	viewBox: "0 0 29 29",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Material-Design-Stickersheet",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Unvollst\\xE4ndige-Bewertungen",
			transform: "translate(-1061.000000, -225.000000)",
			fill: "#F8B477",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group-4",
				transform: "translate(138.000000, 213.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "editing",
					transform: "translate(923.000000, 12.000000)",
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M23.1627907,12.8139535 C22.7004279,12.8139535 22.3255814,13.1888 22.3255814,13.6511628 L22.3255814,25.9302326 C22.3255814,26.6996279 21.6996279,27.3255814 20.9302326,27.3255814 L3.06976744,27.3255814 C2.30037209,27.3255814 1.6744186,26.6996279 1.6744186,25.9302326 L1.6744186,8.06976744 C1.6744186,7.30037209 2.30037209,6.6744186 3.06976744,6.6744186 L15.3488372,6.6744186 C15.8112,6.6744186 16.1860465,6.29957209 16.1860465,5.8372093 C16.1860465,5.37484651 15.8112,5 15.3488372,5 L3.06976744,5 C1.37709767,5 0,6.37709767 0,8.06976744 L0,25.9302326 C0,27.6229023 1.37709767,29 3.06976744,29 L20.9302326,29 C22.6229023,29 24,27.6229023 24,25.9302326 L24,13.6511628 C24,13.1888 23.6251535,12.8139535 23.1627907,12.8139535 Z",
						id: "Path"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M28.4157387,2.19895501 L26.8010405,0.58425486 C26.0220921,-0.19475162 24.7545383,-0.19475162 23.9754186,0.58425486 L11.0582327,13.5015136 C10.9386931,13.6210533 10.8572304,13.7733038 10.8240059,13.9390839 L10.0166283,17.9757486 C9.960512,18.2565015 10.0483685,18.5467308 10.2508551,18.7491606 C10.4130385,18.9113442 10.6315094,19 10.856317,19 C10.9122049,19 10.9683782,18.9945197 11.0242091,18.9833877 L15.0608689,18.1760091 C15.2266488,18.1428417 15.3788991,18.0613217 15.4984387,17.941782 L28.4157387,5.02458037 C28.4157387,5.02458037 28.4157958,5.02458037 28.4157958,5.02452329 C29.1947442,4.2455739 29.1947442,2.97801858 28.4157387,2.19895501 Z M14.4708204,16.547494 L11.9479294,17.0521413 L12.4525761,14.5292472 L22.9662394,4.01539992 L24.9845978,6.03376083 L14.4708204,16.547494 Z M27.2047579,3.81359808 L26.1955787,4.82277853 L24.1772202,2.80441762 L25.1863423,1.79529424 C25.2976615,1.68397498 25.4787406,1.6839179 25.5900597,1.79523716 L27.2047008,3.40993731 C27.316077,3.52119948 27.316077,3.7023359 27.2047579,3.81359808 Z",
						id: "Shape"
					})]
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgIconEditieren);
export { ForwardRef as ReactComponent };
